import { initAcServices } from "AC/helpers/admin-columns";
import ConditionForm from "./components/ConditionForm.svelte";
import { mapConditionsToOptions } from "./helper/mapping";
initAcServices().addListener('Settings.Column.Init', (column) => {
    column.getElement().querySelectorAll('input[data-ac-component="cf_conditions"]').forEach((el) => {
        new ConditionSetting(column, el);
    });
});
class ConditionSetting {
    constructor(column, input) {
        this.column = column;
        this.input = input;
        this.init();
    }
    init() {
        let element = document.createElement('div');
        let value = this.input.value ? JSON.parse(this.input.value) : [];
        new ConditionForm({
            target: element,
            props: {
                conditions: mapConditionsToOptions(acp_cf_settings.operators),
                inputElement: this.input,
                value: value
            }
        });
        this.input.parentElement.append(element);
    }
}
